var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComplain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 8a1 1 0 0 1 1 1v4.444a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1zM12 15.111a1 1 0 0 1 1 1V17a1 1 0 1 1-2 0v-.889a1 1 0 0 1 1-1z",
    fill: "#81A63D",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.166 18.132C2.71 18.92 3.266 20 4.357 20h15.536c1.091 0 1.646-1.08 1.191-1.868L13.316 4.666c-.512-.888-1.87-.888-2.382 0zM4.357 22c-2.498 0-4.212-2.633-2.924-4.867L9.201 3.666c1.282-2.221 4.566-2.221 5.848 0l7.768 13.467C24.105 19.367 22.39 22 19.893 22z",
    fill: "#81A63D",
    opacity: 1,
    "data-original": "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplain);
export default __webpack_public_path__ + "static/media/complain.a2dc37306e0e783945d35356718e3dda.svg";
export { ForwardRef as ReactComponent };